const autoNgTemplateLoaderTemplate1 = require('./entity-profile.template.html');
const autoNgTemplateLoaderTemplate2 = require('./entity-profile.template.html');

'use strict';

(function () {
    angular
        .module('app.entityProfile', [])
        .config(entityProfileConfig);

    entityProfileConfig.$inject = ['$routeProvider'];

    function entityProfileConfig($routeProvider) {
        $routeProvider
            .when('/entity-profile/:id', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'EntityProfileController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                }
            })
            .when('/entity-profile', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate2,
                controller: 'EntityProfileController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                }
            })
    }
})();
